import { EnvironmentUrls } from 'Roblox';

const { billingApi } = EnvironmentUrls;

export const getRobloxCreditBalanceUrlConfig = () => ({
  retryable: true,
  withCredentials: true,
  url: `${billingApi}/v1/credit`
});

export const redeemRobuxUrlConfig = () => ({
  withCredentials: true,
  url: `${billingApi}/v1/credit/redeem-robux`
});
